module.exports = __webpack_public_path__ + "img/2021_SA_NAV_ICONS-06.svg";